import React from "react";
import { Grid, Typography } from "@mui/material";
import { VehicleTextField } from "../VehicleFormFields";

const GpsTab: React.FC = () => {
  return (
    <>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        GPS and tracking system configuration.
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <VehicleTextField 
            name="gpsType" 
            label="GPS Type" 
            placeholder="e.g., Samsara, PeopleNet"
            tooltip="Type or brand of GPS tracking system installed"
          />
        </Grid>
      </Grid>
    </>
  );
};

export default GpsTab;
